import { c as _c } from "react/compiler-runtime";
import { isVaultDataDecrypted, isVaultDataEmpty, type VaultValue } from '@onefootprint/core';
import type { DataIdentifier } from '@onefootprint/types';
import type { Transforms } from '@onefootprint/types/src/data/entity';
import type React from 'react';
import type { JSX } from 'react';
import FieldOrPlaceholder from '@/components/field-or-placeholder';
export type FieldValueProps = {
  field: Record<string, boolean | string | DataIdentifier | VaultValue | Transforms | null | undefined>;
  renderValue?: (value: VaultValue, isValueDecrypted: boolean, monospaced?: boolean) => React.ReactNode;
  monospaced?: boolean;
};
const FieldValue = t0 => {
  const $ = _c(9);
  const {
    field,
    renderValue,
    monospaced
  } = t0;
  const {
    isAutoDecrypting,
    value,
    transforms
  } = field;
  if (isVaultDataEmpty(value) || !renderValue) {
    const t1 = transforms as Transforms;
    const t2 = Boolean(isAutoDecrypting);
    let t3;
    if ($[0] !== monospaced || $[1] !== t1 || $[2] !== t2 || $[3] !== value) {
      t3 = <FieldOrPlaceholder data={value} transforms={t1} isLoading={t2} monospaced={monospaced} />;
      $[0] = monospaced;
      $[1] = t1;
      $[2] = t2;
      $[3] = value;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t1;
  if ($[5] !== monospaced || $[6] !== renderValue || $[7] !== value) {
    t1 = renderValue(value, isVaultDataDecrypted(value), monospaced);
    $[5] = monospaced;
    $[6] = renderValue;
    $[7] = value;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1 as JSX.Element;
};
export default FieldValue;